//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'ProfileProgressDialog',

	methods: {
		dismissProfileProgressDialog() {
			this.$emit('closed');

			this.$store.dispatch(
				'profile/progress/dismissProfileProgressDialog',
			);
		},
	},
};
